import React from 'react';
import S from './Label.styles';
const Label = ({ children, fontStyle = 'default', ...otherProps }) => {
    return (React.createElement(S.Label, { "data-font-style": fontStyle, ...otherProps }, children));
};
export default Label;
